<pc-check>
  <form onsubmit="{ onFormSubmit }" class="login-form">
    <div if="{ props.pcCheckError === 1 }">
      <div>サーバーに接続できませんでした。</div>
      <div>インターネットの設定を確認してください。</div>
      <button class="btn btn-blue" onclick="{ props.restartVP }">再起動する</button>
    </div>
    <div class="form-group">
      サーバーNo: {getServerNo()}
    </div>
    <div class="form-group">
      <label class="form-label" for="credentials">事業所IDとAPIキー</label>
      <input 
        ref="credentialsInput"
        class="form-control" 
        type="text" 
        name="credentials" 
        id="credentials" 
        value="{ getInitialValue() }" 
        oninput="{ validateCredentials }"
        required>
      <small style="color: #666; margin-top: 4px; display: block;">
        事業所IDとAPIキーを半角スペース区切りで入力してください
      </small>
    </div>

    <button class="btn btn-green login-btn">送信</button>
  </form>
  <script>
    import { serializeForm } from '@/common/utils/dom';
    import { notifyLoadDone } from '../vp-notify';
    import tabChannel from '@/worker/tab-channel/top';
    export default {
      onMounted() {
        tabChannel.init();
        notifyLoadDone();
      },

      getServerNo() {
        const match = location.hostname.match(/^cti(\d{1,4})/);
        if (match == null) {
          return 1;
        }
        return match[1] ?? 1;
      },

      getInitialValue() {
        const { officeId, apiKey } = this.props;
        if (!officeId && !apiKey) return '';
        return `${officeId || ''} ${apiKey || ''}`.trim();
      },

      validateCredentials(e) {
        const input = e.target;
        const value = input.value.trim();
        
        // 空の場合はrequired属性に任せる
        if (!value) {
          input.setCustomValidity('');
          return;
        }
        
        const parts = value.split(/\s+/);
        
        if (!parts.at(0) || !parts.at(1)) {
          input.setCustomValidity('事業所IDとAPIキーの両方を入力してください');
          return;
        }

        input.setCustomValidity('');
      },

      onFormSubmit(e) {
        e.preventDefault();
        const formData = serializeForm(e.target);
        const parts = (formData.credentials || '').trim().split(/\s+/);

        this.props.pcCheck({
          officeId: parts.at(0),
          apiKey: parts.at(1)
        }, this.props.pc);
      }
    };
  </script>
</pc-check>